export default __webpack_public_path__ + "static/media/cityuse.fe9748aa.jpg";